/** @format */
import { Context, createContext } from 'react';

import { MarketCode } from '@toucan/config/markets';

import { Model } from '@toucan/types/model';
import { SavedProduct } from '@toucan/types/product';

import { User } from '@toucan/common/services/user/types';

export type UserContextProps = {
    user?: User;
    isLoggedIn: boolean;
    geolocatedMarket?: MarketCode;
    getUser: () => Promise<void>;
    isSavedProductsLoading: boolean;
    isSavedModelsLoading: boolean;
    getSavedProducts: () => void;
    isSavedProduct: (id: number | undefined) => boolean;
    addSavedProduct: (id: number) => void;
    removeSavedProduct: (id: number) => void;
    savedProducts: SavedProduct[];
    isSavedModel: (id: number) => boolean;
    getSavedModels: () => void;
    addSavedModel: (id: number) => void;
    removeSavedModel: (id: number) => void;
    savedModels: Model[];

    /**
     * If an initial request to get the user information
     * has taken place
     */
    isInitialised: boolean;
};

export const UserContext: Context<UserContextProps> = createContext(
    {} as UserContextProps
);

UserContext.displayName = 'UserContext';
